const CONNEX_REDUCER_PATH = "connexService";
const CONNEX_SERVICE_TAG = "ConneXLender";

const CONNEX_RELATED_TAGS = [CONNEX_SERVICE_TAG];

export { CONNEX_REDUCER_PATH, CONNEX_SERVICE_TAG, CONNEX_RELATED_TAGS };

